export default {
  functionKey: "JOINDRE.TEXTE",
  title: "JOINDRE.TEXTE",
  group: "Texte",
  origin: [],
  target: [],
  targetRequired: true,
  multiOrigin: true,
  arguments: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Separator", name: "Séparateur" }],
  expectedArguments: [
    { name: "Séparateur", argumentKey: "Separator", single: true, initialValue: ";" }
  ],
  description: "Concatène plusieurs colonnes avec un séparateur. Ajoutez les colonnes en Origine, le séparateur en Argument.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol, allOrigins = []) {
    const cols = allOrigins.length > 0 ? allOrigins : (origin ? [origin] : []);
    const sep = args[0] || "';'";
    if (cols.length === 0) return { displayCode: '', safeCode: '' };
    const safeCode = `${destination}=[${cols.join(',')}].map(function(v){return (v===null||v===undefined)?'':String(v);}).join(${sep});`;
    return { displayCode: safeCode, safeCode };
  }
}
